import { userHasRequiredGroups } from '../utils/userHasRequiredGroups';
import { userIsAuthorizedForBuzz } from '../utils/userIsAuthorizedForBuzz';

/**
 * Hook that will define whether or not the provided groups are authorized accourding to the `requiredGroups` property.
 * @param userGroups
 * @param requiredGroups
 */
export function useRequiredUserGroups(userGroups, requiredGroups) {
  const isAuthorizedForBuzz = userIsAuthorizedForBuzz(userGroups);
  const isAuthorizedForRequiredGroups = isAuthorizedForBuzz && userHasRequiredGroups(userGroups, requiredGroups);
  return {
    isAuthorizedForRequiredGroups,
    isAuthorizedForBuzz,
    userGroups
  };
}